export const TaskModel = {
    path: '/boarding_task_models',
    name: 'boarding_task_models',
    component: () => import('@/views/Boarding/TaskModel/TaskModelPage.vue'),
    children: [
        {
            path: '/boarding_task_models/add',
            name: 'boarding_task_models.add',
            component: () => import('@/views/Boarding/TaskModel/Form/TaskModelForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/boarding_task_models/edit/:id',
            name: 'boarding_task_models.edit',
            component: () => import('@/views/Boarding/TaskModel/Form/TaskModelForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/boarding_task_models/delete/:id',
            name: 'boarding_task_models.delete',
            component: () => import('@/views/Boarding/TaskModel/Form/TaskModelForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/boarding_task_models/view/:id',
            name: 'boarding_task_models.view',
            component: () => import('@/views/Boarding/TaskModel/Form/TaskModelForm.vue'),
            props: {viewAction: true}
        },
    ],
}